/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module Facets
define('Facets.Browse.View'
,	[	'SC.Configuration'
	,	'LiveOrder.Model'
	,	'LiveOrder.Line.Model'
	,	'Product.Model'
	,	'Profile.Model'
	,	'Facets.Helper'
	,	'Categories'
	,	'Categories.Utils'
	,	'Facets.FacetedNavigation.View'
	,	'Facets.FacetedNavigationItem.View'
	,	'Facets.FacetsDisplay.View'
	,	'Facets.ItemListDisplaySelector.View'
	,	'Facets.ItemListSortSelector.View'
	,	'Facets.ItemListShowSelector.View'
	,	'Facets.ItemCell.View'
	,	'Facets.Empty.View'
	,	'Facets.Browse.CategoryHeading.View'
	,	'Facets.CategoryCell.View'
	,	'Facets.CategoryCellColumn.View'
	,	'Facets.FacetedNavigationItemCategory.View'
	,	'Facets.Helper'
	,	'GlobalViews.Pagination.View'
	,	'Tracker'
	,	'ProductList.Control.View'
	,	'ProductList.ControlSingle.View'
	,	'ProductList.Details.View'
	,	'ProductDetailToQuote.View'

	,	'facets_facet_browse.tpl'
	,	'facets_items_collection.tpl'
	,	'facets_items_collection_view_cell.tpl'
	,	'facets_items_collection_view_row.tpl'

	,	'Backbone'
	,	'Backbone.CollectionView'
	,	'Backbone.CompositeView'
	,	'underscore'
	,	'jQuery'
	,	'Utils'
	,	'Bootstrap.Slider'
	]
,	function (
		Configuration
	,	LiveOrderModel
	,	LiveOrderLineModel
	,	ProductModel
	,	ProfileModel
	,	Helper
	,	Categories
	,	CategoriesUtils
	,	FacetsFacetedNavigationView
	,	FacetsFacetedNavigationItemView
	,	FacetsFacetsDisplayView
	,	FacetsItemListDisplaySelectorView
	,	FacetsItemListSortSelectorView
	,	FacetsItemListShowSelectorView
	,	FacetsItemCellView
	,	FacetsEmptyView
	,	FacetsBrowseCategoryHeadingView
	,	FacetsCategoryCellView
	,	FacetsCategoryCellColumnView
	,	FacetsFacetedNavigationItemCategoryView
	,	FacetsHelper
	,	GlobalViewsPaginationView
	,	Tracker
	,	ProductListControlView
	,	ProductListControlSingleView
	,	ProductListDetailsView
	,	ProductDetailToQuoteView

	,	facets_facet_browse_tpl
	,	facets_items_collection_tpl
	,	facets_items_collection_view_cell_tpl
	,	facets_items_collection_view_row_tpl

	,	Backbone
	,	BackboneCollectionView
	,	BackboneCompositeView

	,	_
	,	jQuery
	,	Utils
	)
{
	'use strict';


	// statuses stores the statuses of the collapsible facets
	var statuses = window.statuses = {}
		// collapsable_elements stores the statuses of the collapsible elements. This store elements collapsable that are not facets
		/*
		each object should be of the form
		{
			selector: '' //id of the element that will collapsed/expanded
		,	collapsed: true/false
		}
		*/
	,	collapsable_elements = window.collapsable_elements = {};

	//@class Facets.Browse.View View that handles the item list @extends Backbone.View
	return Backbone.View.extend({

		template: facets_facet_browse_tpl

	,	description: _('This is a description').translate()

	,	attributes: {
			'id': 'facet-browse'
		,	'class': 'view facet-browse'
		,	'data-root-component-id': 'Facets.Browse.View'
		}

	,	events: {
			'click [data-toggle="facet-navigation"]': 'toggleFacetNavigation'
		,	'click [data-action="toggle-filters"]': 'toggleFilters'

		,	'click [data-view="Facets.FacetsDisplay"] a': '_gotoFacets'
		,	'click [data-view="Facets.FacetedNavigation"] a': '_gotoFacets'
		,	'click [data-view="GlobalViews.Pagination"] a': '_gotoPage'
		,	'click [data-view="Facets.ItemListDisplaySelector"] a': '_gotoDisplay'
		,	'change [data-view="Facets.ItemListShowSelector"] select': '_gotoShow'
		,	'change [data-view="Facets.ItemListSortSelector"] select': '_gotoOrder'
		,	'change [data-number]': 'changeQuantity'
		,	'change [data-attr="unitstype"]': 'changeUnitsType'
		,	'click	[data-action="add-to-cart"]': 'addToCart'
		,	'click	[data-fav="change-icon"]':	'changeIcon'
		}

	,	initialize: function (options)
		{
			BackboneCompositeView.add(this);
			this.statuses = statuses;
			this.collapsable_elements = collapsable_elements;
			this.translator = this.setOptionsTranslator(options.translator);
			this.application = options.application;
			this.options = options;

			this.itemsDisplayOptions = Utils.deepCopy(options.application.getConfig('itemsDisplayOptions'));
			this.resultsPerPage = Utils.deepCopy(options.application.getConfig('resultsPerPage'));
			this.sortOptions = Utils.deepCopy(options.application.getConfig('sortOptions'));

			_.each(this.resultsPerPage, function(perPage)
			{
				perPage.id = String(perPage.items);
			});

			this.cart = LiveOrderModel.getInstance();

			this.collapsable_elements['facet-header'] = this.collapsable_elements['facet-header'] || {
				selector: 'this.collapsable_elements["facet-header"]'
			,	collapsed: false
			};
			
			var self = this
			,	itemid = this.model.get('items').map(function(model){ return model.get('internalid');});

			var itemid_stringify = JSON.stringify(itemid);
			var itemid_to_be_passed = itemid_stringify.slice(1,-1);

			Backbone.ajax({
				url: Utils.getAbsoluteUrl('services/GetUOM.Service.ss'),
				data: {itemid:itemid_to_be_passed},
				success: function(val){
					//var units = JSON.parse(val);
					self.model.get('items').forEach(function(item){	
					var unitsObj = _.find(val , function(id){
							return id.internalid == item.get('internalid');
						});
						item.set('unitsType', unitsObj ? unitsObj.unitstype : []);							
						});
						self.render();
				}
			});
			
			this.Profile = ProfileModel.getInstance();

			this.itemModel = []; 
			
			this.application.ProductListModule.Utils.getProductListsPromise().done(function(listCollection){
				
				self.ProductListCollection = listCollection;
				if( self.Profile.get('isLoggedIn') == "T" && self.Profile.get('isGuest') == "F" )
				{
					_.each(self.ProductListCollection.models,function(list){
						if(list.get('name') == "Favorites")
						{
							self.wishList = list;
						}
					});
					self.customizedOptions = {
						application : self.application
					,	includeSortingFilteringHeader : false
					,	model : self.wishList
					,	params : {}
					};
					self.wishListItems = !_.isEmpty(self.wishList) ? self.wishList.get('items') : [];
				}

			}); 
			
			// if(this.Profile.get('isLoggedIn') == "T")
			// 	_.delay(self.waitForData,2000,self);

			var parentUrl = this.model.get('category') ? this.model.get('category').get('parenturl') : "" ;
			this.isSubcategory = parentUrl !== "" && parentUrl !== undefined ? true : false; 

		}

		// @method getPagination Return the info of the current options in the PLP
		// @return {Object}
	,	getPagination: function getPagination()
		{
			return {
				currentPage: this.translator.getOptionValue('page')
			,	pageCount: this.totalPages
			,	itemCount: this.model.get('total')
			,	pageSize: parseInt(this.translator.getOptionValue('show'), 10)
			,	sorting: this.translator.getOptionValue('order')
			,	display: this.translator.getOptionValue('display')
			,	filters: this._getFacetsTranslator(this.translator)
			,	searchText: this.translator.getOptionValue('keywords')
			};
		}

	,	_setEvent: function _setEvent(options)
		{
			this.setEvent(options.eventName, options.value).fail(function()
			{
				if (options.event.currentTarget.nodeName === 'SELECT')
				{
					options.event.currentTarget.value = options.valueOriginal;
				}

				options.event.stopPropagation();
				options.event.preventDefault();
			});

		}

	,	_getFacetsTranslator: function(translator)
		{
			var facets = {}
			,	allFacets = translator.getAllFacets();

			_.each(allFacets, function(facet)
			{
				facets[facet.url] = facet.value;
			});

			return facets;
		}

	,	_gotoFacets: function _gotoFacet (e)
		{
			var url = e.currentTarget.href
			,	translator = FacetsHelper.parseUrl(url, this.translator.configuration, !!this.model.get('category'));

			this._setEvent({ event: e, eventName: 'Filters', value: this._getFacetsTranslator(translator) });
		}

	,	_gotoDisplay: function gotoDisplay(e)
		{
			var default_value = _.find(this.itemsDisplayOptions, function(result) { return result.isDefault; }).id
			,	display = Utils.getParameterByName(e.currentTarget.href, 'display') || default_value;

			this._setEvent({ event: e, eventName: 'Display', value: display });
		}

	,	_gotoShow: function gotoShow(e)
		{
			var original = this.translator.getUrl()
			,	default_value = _.find(this.resultsPerPage, function(result) { return result.isDefault; }).id
			,	show = parseInt(Utils.getParameterByName(e.currentTarget.value, 'show'), 10) || default_value;

			this._setEvent({ event: e, eventName: 'PageSize', value: show, valueOriginal: original });
		}

	,	_gotoOrder: function gotoOrder(e)
		{
			var original = this.translator.getUrl()
			,	default_value = _.find(this.sortOptions, function(result) { return result.isDefault; }).id
			,	order = Utils.getParameterByName(e.currentTarget.value, 'order') || default_value;

			this._setEvent({ event: e, eventName: 'Sorting', value: order, valueOriginal: original });
		}

	,	_gotoPage: function gotoPage (e)
		{
			var order = parseInt(Utils.getParameterByName(e.currentTarget.href, 'page'), 10) || 1;

			this._setEvent({ event: e, eventName: 'CurrentPage', value: order });
		}

	,	setEvent: function setEvent(event_name, value)
		{
			var self = this
			,	pagination = this.getPagination();

			pagination['set' + event_name] = value;

			return this.model.cancelableTrigger('before:FacetModel.set' + event_name, pagination).done(function()
			{
				Backbone.history.once('route', function()
				{
					var pagination = self.getPagination();

					pagination[event_name.charAt(0).toLowerCase() + event_name.slice(1)] = value;
					self.model.cancelableTrigger('after:FacetModel.set' + event_name, pagination);
				});
			});
		}

		//@method toggleFilters
	,	toggleFilters: function (e)
		{
			e.preventDefault();

			var current_target = jQuery(e.currentTarget);

			this.collapsable_elements['facet-header'].collapsed = !this.collapsable_elements['facet-header'].collapsed;

			current_target.find('.filter-icon').toggleClass('icon-chevron-up');

			current_target.parents('[data-type="accordion"]')
				.toggleClass('well')
				.toggleClass('facet-header-white-well')
				.find('[data-type="accordion-body"]').stop().slideToggle();
		}

		//@method getPath
	,	getPath: function ()
		{
			var base_url = window.location.protocol + '//' + window.location.hostname;
			if (this.model.get('category'))
			{
				var category_canonical = this.model.get('category').get('canonical') || this.model.get('category').get('fullurl');
				return (category_canonical.indexOf('/') === 0 ? base_url : '') + category_canonical;
			}
			else
			{
				var canonical = base_url + '/' + Backbone.history.fragment
				,	index_of_query = canonical.indexOf('?');

				// !~ means: indexOf == -1
				return !~index_of_query ? canonical : canonical.substring(0, index_of_query);
			}
		}

		//@method getCanonical
	,	getCanonical: function ()
		{
			var canonical_url = this.getPath()
			,	current_page = this.translator.getOptionValue('page');

			if (current_page > 1)
			{
				canonical_url += '?page=' + current_page;
			}

			return canonical_url;
		}

		//@method getRelPrev
	,	getRelPrev: function ()
		{
			var previous_page_url = this.getPath()
			,	current_page = this.translator.getOptionValue('page');

			if (current_page > 1)
			{
				if (current_page === 2)
				{
					return previous_page_url;
				}

				if (current_page > 2)
				{
					return previous_page_url += '?page=' + (current_page - 1);
				}
			}

			return null;
		}

		//@method getRelNext
	,	getRelNext: function ()
		{
			var next_page_url = this.getPath()
			,	current_page = this.translator.getOptionValue('page');

			if (current_page < this.totalPages)
			{
				return next_page_url += '?page='+ (current_page + 1);
			}

			return null;
		}

		//@method formatFacetTitle: accepts a facet object and returns a string formatted to be displayed on the document's title according with user facet configuration property titleToken
		//@param {Object} facet @returns {String}
	,	formatFacetTitle: function (facet)
		{
			var defaults = {
				range: '$(2): $(0) to $(1)'
			,	multi: '$(1): $(0)'
			,	single: '$(1): $(0)'
			};

			if (!facet.config.titleToken)
			{
				facet.config.titleToken = defaults[facet.config.behavior] || defaults.single;
			}
			if (_.isFunction(facet.config.titleToken))
			{
				return facet.config.titleToken(facet);
			}
			else if (facet.config.behavior === 'range')
			{
				return _(facet.config.titleToken).translate(facet.value.to, facet.value.from, facet.config.name);
			}
			else if (facet.config.behavior === 'multi')
			{
				var buffer = [];
				_.each(facet.value, function (val)
				{
					buffer.push(val);
				});
				return _(facet.config.titleToken).translate(buffer.join(', '), facet.config.name);
			}
			else
			{
				var value = this.translator.getLabelForValue(facet.config.id, facet.value);

				return _(facet.config.titleToken).translate(value, facet.config.name);
			}
		}

		// @method getTitle overrides Backbone.Views.getTitle
	,	getTitle: function ()
		{
			if (this.title)
			{
				return this.title;
			}

			var facets = this.options.translator.facets
			,	category = this.model.get('category')
			,	title = category ? category.get('pagetitle') || _.pluck(this.getBreadcrumbPages(), 'text').join(' > ') : this.title;

			if (facets && facets.length)
			{
				var buffer = []
				,	facet = null;

				for (var i = 0; i < facets.length; i++)
				{
					facet = facets[i];
					buffer.push(this.formatFacetTitle(facet));

					if (i < facets.length - 1)
					{
						buffer.push(facet.config.titleSeparator || ', ');
					}
				}

				title = title ? title + ' - ' : '';

				title = this.application.getConfig('searchTitlePrefix', '') +
						buffer.join('') +
						this.application.getConfig('searchTitleSuffix', '');
			}
			else if (this.translator.getOptionValue('keywords'))
			{
				title = _('Search results for "$(0)"').translate(
					this.translator.getOptionValue('keywords')
				);
			}
			else
			{
				title = title || this.application.getConfig('defaultSearchTitle', '');
			}

			// Update the meta tag 'twitter:title'
			this.setMetaTwitterTitle(title);

			return title;
		}

		// @method getMetaDescription Get view's SEO attributes @return {String}
	,	getMetaDescription: function ()
		{
			var category = this.model.get('category');

			return category && category.get('metadescription') || this.metaDescription;
		}

		// @method getMetaKeywords @return {String}
	,	getMetaKeywords: function ()
		{
			var category = this.model.get('category');

			return category && category.get('metakeywords') || this.metaKeywords;
		}

	,	getAddToHead: function ()
		{
			var category = this.model.get('category');

			return category && category.get('addtohead') || this.addToHead;
		}

		// @method setMetaTwitterTitle @param {Strnig}title
	,	setMetaTwitterTitle: function (title)
		{
			var seo_twitter_title = jQuery('meta[name="twitter:title"]');
			seo_twitter_title && seo_twitter_title.attr('content', title);
		}

		//@method setOptionsTranslator Set up the default option for displaying the facets.
		//If we are in a small device, we've got to omit the 'grid' display option,
		//for it is not showing in this kind of devices. We must change it for 'table'
		//@param {Facets.Translator} translator
		//@return {Facets.Translator}
	,	setOptionsTranslator: function (translator)
		{
			if (translator.options.display === 'grid' && _.isPhoneDevice())
			{
				translator.options.display = 'table';
			}
			return translator;
		}

		// @method showContent overrides Backbone.View.showContent to works with the title to find the proper wording and calls the layout.showContent
	,	showContent: function ()
		{
			// If its a free text search it will work with the title
			var self = this
			,	keywords = this.translator.getOptionValue('keywords')
			,	resultCount = this.model.get('total');

			if (keywords)
			{
				keywords = decodeURIComponent(keywords);

				if (resultCount > 0)
				{
					this.subtitle =  resultCount > 1 ? _('Results for "$(0)"').translate(keywords) : _('Result for "$(0)"').translate(keywords);
				}
				else
				{
					this.subtitle = _('We couldn\'t find any items that match "$(0)"').translate(keywords);
				}
			}

			this.totalPages = Math.ceil(resultCount / this.translator.getOptionValue('show'));

			this.application.getLayout().showContent(this).done(function ()
			{
				if(jQuery.fn.scPush)
				{
					self.$el.find('[data-action="pushable"]').scPush({target: 'tablet'});
				}

				Tracker.getInstance().trackEvent({
				category: 'SearchItem-end'
				,	action: 'render'
				,	value: 1
				});
			});
		}

	,	render: function()
		{
			var list_type = 'Facets';

			if (this.model.get('category'))
			{
				list_type = 'Category';
			}
			else if (this.translator.getOptionValue('keywords'))
			{
				list_type = 'Search';
			}

			Tracker.getInstance().trackProductList(this.model.get('items'), list_type);

			this._render();
		}

		// @method getBreadcrumbPages
		// It will generate an array suitable to pass it to the breadcrumb macro
		// It looks in the category facet value
		// @return {Array<Object>}
	,	getBreadcrumbPages: function ()
		{
			var breadcrumb = [];

			if (this.model.get('category'))
			{
				var list = this.model.get('category').get('breadcrumb')
				,	self = this;

				_.each(list, function(bread)
				{
					breadcrumb.push({
						'text': bread.name
					,	'href': bread.fullurl
					,	'additionalFields': CategoriesUtils.getAdditionalFields(self.model.get('category').attributes, 'categories.breadcrumb.fields')
					});
				});

				return breadcrumb;
			}
			else if (this.translator.getOptionValue('keywords'))
			{
				breadcrumb.push({
					href: '#'
				,	text: _('Search Results').translate()
				});
			}
			else
			{
				breadcrumb.push({
					href: '#'
				,	text: _('Shop').translate()
				});
			}

			return breadcrumb;
		}

		// @method toggleFacetNavigation Hides/Shows the facet navigation area
	,	toggleFacetNavigation: function ()
		{
			this.$el.toggleClass('narrow-by');
			this.toggleNavigationListener(this.$el.hasClass('narrow-by'));
		}

		// @method toggleNavigationListener
		// adds/removes event listeners to the HTML to hide the facet navigation area
		// @param {Boolean} isOn
	,	toggleNavigationListener: function (isOn)
		{
			var self = this
			,	touch_started = null;

			// turn listeners on
			if (isOn)
			{
				jQuery('html')
					// we save the time when the touchstart happened
					.on('touchstart.narrow-by', function ()
					{
						touch_started = new Date().getTime();
					})
					// code for touchend and mousdown is the same
					.on('touchend.narrow-by mousedown.narrow-by', function (e)
					{
						// if there wasn't a touch event, or the time difference between
						// touch start and touch end is less that 200 miliseconds
						// (this is to allow scrolling without closing the facet navigation area)
						if (!touch_started || new Date().getTime() - touch_started < 200)
						{
							var $target = jQuery(e.target);

							// if we are not touching the narrow by button or the facet navigation area
							if (!$target.closest('[data-toggle="facet-navigation"]').length && !$target.closest('#faceted-navigation').length)
							{
								// we hide the navigation
								self.toggleFacetNavigation();
							}
						}
					});
			}
			else
			{
				jQuery('html')
					// if the navigation area is hidden, we remove the event listeners from the HTML
					.off('mousedown.narrow-by touchstart.narrow-by touchend.narrow-by');
			}
		}

	,	contextData: {
			'itemList': function ()
			{
				return Utils.deepCopy(this.model.get('items'));
			}
		,	'category': function ()
			{
				return Utils.deepCopy(this.model.get('category'));
			}
		}

	,	childViews: {
			'Facets.FacetedNavigation': function (options)
			{
				var exclude = _.map((options.excludeFacets || '').split(','), function (facet_id_to_exclude)
					{
						return jQuery.trim( facet_id_to_exclude );
					})
				,	has_categories = !!(this.category && this.category.categories)
				,	has_items = this.model.get('items').length
				,	has_facets = has_items && this.model.get('facets').length
				,	applied_facets = this.translator.cloneWithoutFacetId('category').facets
				,	has_applied_facets = applied_facets.length;

				return new FacetsFacetedNavigationView({
					categoryItemId: this.category && this.category.itemid
				,	clearAllFacetsLink: this.translator.cloneWithoutFacets().getUrl()
				,	hasCategories: has_categories
				,	hasItems: has_items

					// facets box is removed if don't find items
				,	hasFacets: has_facets

				,	hasCategoriesAndFacets: has_categories && has_facets

					// Categories are not a real facet, so lets remove those
				,	appliedFacets: applied_facets

				,	hasFacetsOrAppliedFacets: has_facets || has_applied_facets

				//,	translatorUrl: this.translator.getUrl()
				,	translator: this.translator

				//,	translatorConfig: this.options.translatorConfig
				,	facets: _.filter(this.model.get('facets'), function (facet)
					{
						return !_.contains(exclude, facet.id);
					})

				,	totalProducts: this.model.get('total')
				,	keywords: this.translator.getOptionValue('keywords')
				});
			}

		,	'Facets.FacetsDisplay': function()
			{
				var facets = this.translator.cloneWithoutFacetId('category').getAllFacets().sort(function (a, b) {
					return b.config.priority - a.config.priority;
				});

				return new FacetsFacetsDisplayView({
					facets: facets
				,	translator: this.translator
				});
			}

		,	'Facets.ItemListDisplaySelector': function()
			{
				return new FacetsItemListDisplaySelectorView({
					configClasses: 'pull-right'
				,	options: this.itemsDisplayOptions
				,	translator: this.translator
				});
			}

		,	'Facets.ItemListSortSelector': function()
			{
				return new FacetsItemListSortSelectorView({
					options: this.sortOptions
				,	translator: this.translator
				});
			}
			//Show 'XX products per page' View
		,	'Facets.ItemListShowSelector': function()
			{
				return new FacetsItemListShowSelectorView({
					options: this.resultsPerPage
				,	translator: this.translator
				});
			}
			//Extra Facet filter View
		,	'Facets.FacetedNavigation.Item': function (options)
			{
				var facet_config = this.translator.getFacetConfig(options.facetId)
				,	contructor_options = {
						model: new Backbone.Model(_.findWhere(this.model.get('facets'), {id: options.facetId}))
					,	translator: this.translator
					};

				if (facet_config.template)
				{
					contructor_options.template = facet_config.template;
				}

				return new FacetsFacetedNavigationItemView(contructor_options);
			}
		,	'Facets.Items': function()
			{
				var self = this
				,	display_option = _.find(this.itemsDisplayOptions, function (option)
					{
						return option.id === self.options.translator.getOptionValue('display');
					});

				return new BackboneCollectionView({
					childTemplate: display_option.template
				,	childView: FacetsItemCellView
				,	childViewOptions: {
						application: this.application
					,	ProductListCollection: this.ProductListCollection
					}
				,	viewsPerRow: parseInt(display_option.columns, 10)
				,	collection: this.model.get('items')
				,	cellTemplate: facets_items_collection_view_cell_tpl
				,	rowTemplate: facets_items_collection_view_row_tpl
				,	template: facets_items_collection_tpl
				,	context: {
						keywords: this.translator.getOptionValue('keywords')
					}
				});
			}
		,	'Facets.Items.Empty': function()
			{
				return new FacetsEmptyView({
					keywords: this.translator.getOptionValue('keywords')
				});
			}
		,	'GlobalViews.Pagination': function()
			{
				var translator = this.translator;

				return new GlobalViewsPaginationView(_.extend({
					currentPage: translator.getOptionValue('page')
				,	totalPages: this.totalPages
				,	pager: function (page) {
						return translator.cloneForOption('page', page).getUrl();
					}
				}, Configuration.defaultPaginationSettings));
			}

		,	'Facets.Browse.CategoryHeading': function()
			{
				return new FacetsBrowseCategoryHeadingView({
					model: this.model.get('category')
				,	showDescription: this.translator.cloneWithoutFacetId('category').getAllFacets().length === 0
				});
			}

		,	'Facets.CategoryCells': function()
			{
				return new BackboneCollectionView({
					childView: this.isSubcategory ? FacetsCategoryCellColumnView :FacetsCategoryCellView
				,	collection: this.model.get('category') ? this.model.get('category').get('categories') : []
				});
			}

		,	'Facets.CategorySidebar': function()
			{
				return new FacetsFacetedNavigationItemCategoryView({
					model: this.model.get('category')
				,	categoryUrl: this.translator.getCategoryUrl()
				});
			}

		}

	,	changeQuantity: function(e)
		{
			var itemid = jQuery(e.target).attr("data-item-id")
			,	attribute = jQuery(e.target).attr("data-attr")
			,	value = parseInt(jQuery(e.target).val())
			,	$otherEl = jQuery("[data-attr='unitstype']").closest("[data-item-id="+itemid+"]")
			,	optionalAttr = {}
			,	text = $otherEl.find('option:selected').text().trim();
			
			optionalAttr.attribute = $otherEl.attr('data-attr');
			optionalAttr.value = {};
			optionalAttr.value.id = $otherEl.val();
			optionalAttr.value.text = text;//.substr(0,text.lastIndexOf(' '));
			
			if( parseInt(jQuery(e.target).val()) > 0 )
			{
				this.changeAttribute(itemid, attribute, value , optionalAttr)
			}
			else
			{
				var lineItem = _.find(this.itemModel,function(line){
					return line.get('item').get('internalid') == itemid ;	
				});
				var linesToCart = _.reject(this.itemModel, function(num){ return num.id == lineItem.id ;});
				this.itemModel = linesToCart;
				jQuery(e.target).val("");
			}	
		}
	
	,	changeUnitsType: function(e)
		{
			var itemid = jQuery(e.target).attr("data-item-id")
			,	attribute = jQuery(e.target).attr("data-attr")
			,	optionalAttr = {}
			,	$qtyEl = jQuery("[data-attr='quantity']").closest("[data-item-id="+itemid+"]")
			,	qty = $qtyEl.val()
			,	value = {}
			,	text = jQuery(e.target).find('option:selected').text().trim();
			
			value.id = jQuery(e.target).val();
			value.text = text;//.substr(0,text.lastIndexOf(' '));

			if(qty)
			{
				optionalAttr.value = qty;
			}
			else{
				optionalAttr.value = 1;
				$qtyEl.text(1);
			}
			optionalAttr.value = qty ? qty : 1 ;
			optionalAttr.attribute = $qtyEl.attr('data-attr');
			
			this.changeAttribute( itemid , attribute , value , optionalAttr );
			
		}
		
	,	changeAttribute: function(itemid,attribute,value,optionalAttr)
		{
			var self = this
			,	item = _.find(self.model.get('items').models,function(item){
				return item.id == itemid;
			});

			if(self.itemModel)
			{
				var isExist = _.filter(self.itemModel,function(item){
					return item.id == itemid;
				}).length ? true : false;

				if(isExist) 
				{
					this.updateItem(item,itemid,attribute,value,optionalAttr) 
				}
				else if(attribute == "unitstype")	//Added recently to not add the item to array on change of unittype field
				{
					return;
				}
				else
				{
					this.addToArray( this.pushItem(item,itemid,attribute,value,optionalAttr) );
				}
			}
			else if(attribute == "unitstype")	//Added recently to not add the item to array on change of unittype field
			{
				return;
			}
			else
			{
				this.addToArray( this.pushItem(item,itemid,attribute,value,optionalAttr) );
			}
		}
		
	,	pushItem: function(item,itemid,attribute,value,optionalAttr)
		{
			var product = new ProductModel({ 
				internalid: itemid
			,	item : item
			});
			
			product.get('options').models = item.get('options').models;
			
			attribute == "unitstype" ? this.addOption(product,value) : product.set(attribute,value);

			optionalAttr.attribute == "unitstype" ? this.addOption(product,optionalAttr.value) : product.set(optionalAttr.attribute , optionalAttr.value);
			
			return product;
		}

	,	updateItem: function(item,itemid,attribute,value,optionalAttr)
		{
			var self = this;
			_.each(this.itemModel,function(item){
				if(item.id == itemid)
				{
					attribute == "unitstype" ? self.addOption(item,value) : item.set(attribute,value);
					return;
				}
			});		
		}

	,	addOption: function(product,value)
		{
			var self = this;
			_.each(product.get('options').models , function(option){

				if(option.get('cartOptionId') == "custcol_appf_custom_uom_website")
				{
					option.set('value',{ internalid:value.id , label:value.id });
					product.set(option.get('cartOptionId'),value.id);
				}
				if(option.get('cartOptionId') == 'custcol_appf_custom_uom_label_website')
				{
					option.set('value', { label: value.text , internalid: value.text });
					product.set('custcol_appf_custom_uom_label_website', value.text );
				}
				if(option.get('cartOptionId') == 'custcol_appf_custom_uom_price_website')
				{
					self.setRate(product,option,value.id);
				}
			});
		}
	,	setRate: function(product,option,unitId)
		{
			var unittype = _.find(product.get('item').get('unitsType'), function(unit){ return unit.id == unitId;})
			,	saleUnitObj = _.findWhere(product.get('item').get('unitsType'), {saleUnit: true})
			,	cRate = unittype ? unittype.convertionRate : ""
			,	newprice = ( ( product.getPrice().price/saleUnitObj.convertionRate ) * cRate)
			,	customprice = newprice.toString();

			if(customprice)
			{
				option.set('value', { label: customprice , internalid: customprice });
				product.set('custcol_appf_custom_uom_price_website', customprice );
			}
		}	
		
	,	addToArray: function(product)
		{
			var line = LiveOrderLineModel.createFromProduct(product);
			this.itemModel.push(line);
		}	
	
	,	changeIcon:	function(e)
		{
			e.stopPropagation();
			var self = this
			,	id =  jQuery(e.target).parent().attr("data-item-id")
			,	selector = "[data-attr='quantity'][data-item-id="+id+"]"
			,	listModelId =  jQuery(e.target).parent().attr("data-list-model-id")
			,	attribute = jQuery(selector).attr("data-attr")
			,	value = parseInt(jQuery(selector).val()) ? parseInt(jQuery(selector).val()) : 1
			,	optionalAttr = {};

			optionalAttr.attribute = jQuery("[data-attr='unitstype']").closest("[data-item-id="+id+"]").attr('data-attr');
			optionalAttr.value = {};
			optionalAttr.value.id = jQuery("[data-attr='unitstype']").closest("[data-item-id="+id+"]").val();
			optionalAttr.value.text = jQuery("[data-attr='unitstype']").closest("[data-item-id="+id+"]").find('option:selected').text().trim();	

			var items = null;
			this.model.get('items').models.forEach(function(item){
				if(item.id == id)
				{
					items = self.pushItem(item,id,attribute,value,optionalAttr);
				}
			});
			
			var controlSingle = new ProductListControlSingleView({	
				collection: this.ProductListCollection
			,	product: items
			,	application: this.application
			});

			var control = new ProductListControlView({	
				collection: this.ProductListCollection
			,	product: items
			,	application: this.application
			});
			
			this.isProductAlreadyAdded = false;
			//this.isProductAlreadyAdded = controlSingle.isProductAlreadyAdded();
			var favItem = _.find(this.wishListItems.models, function(model){
				return model.get('item').get('internalid') == id
			});
			if(favItem)
			{
				this.isProductAlreadyAdded =  true;
			}

			if(this.isProductAlreadyAdded) 
			{
				
				if( !this.wishListItems.get(listModelId).get('checked'))
				{
					this.wishListItems.get(listModelId).set('checked',true);
				}
				
				var deleteList = new ProductListDetailsView(this.customizedOptions);	
				deleteList.deleteItemsHandler(e);	
			}
			else
			{
				control.doAddItemToList(items,this.wishList,true);
			}

			//jQuery('[data-fav="change-icon"]').addClass("disabled");
			_.delay(function(){
				jQuery('[data-toggle="overlay"]').toggle();
				_.delay(function(){
					jQuery('[data-toggle="overlay"]').toggle();
					self.render();
				},2500);
			},0);

			//this.initialize(this.options);
			//Backbone.history.navigate(location.hash,{trigger:true});
			
		}
		
	,	addToCart: function(e)
		{
			e.stopPropagation();

			if(this.itemModel.length > 0)
			{
				jQuery(e.target).attr("disabled",true)
					
				var cart_promise = this.cart.addLines(this.itemModel);
					
				cart_promise.then(function(){
					jQuery(e.target).attr("disabled",false);
				});
				this.itemModel = [];
				jQuery('[data-number]').each(function(){
					jQuery(this).val('');
				});
			}
			return false;
		}

		//@method getContext @returns {Facets.Browse.View.Context}
	,	getContext: function()
		{
			var hasSelectedFacets = this.translator.cloneWithoutFacetId('category').getAllFacets().length
			,	hasSubcategories = this.model.get('category') ? this.model.get('category').get('categories').length : false
			,	hasItems = this.model.get('items') && this.model.get('items').length > 0;

			// @class Facets.Browse.View.Context
			return {
				// @property {Number} total
				total: this.model.get('total')
				// @property {Boolean} isTotalProductsOne
			,	isTotalProductsOne: this.model.get('total') === 1
				// @property {String} title
			,	title: this.getTitle()
				// @property {Boolean} hasItemsAndFacets
			,	hasItemsAndFacets: !!(hasItems && this.model.get('facets').length)
				// @property {Boolean} collapseHeader
			,	collapseHeader: !!(this.collapsable_elements['facet-header'].collapsed)
				// @property {String} keywords
			,	keywords: this.translator.getOptionValue('keywords')
				// @property {Boolean} showResults
			,	showResults: _.isNull(this.translator.getOptionValue('keywords')) ? true : (this.model.get('total') > 0)
				// @property {Boolean} isEmptyList
			,	isEmptyList:  (this.model.get('total') <= 0)

				// @property {Boolean} isCategory
			,	isCategory: !!this.model.get('category')
				
				// @property {Boolean} isSubcategory
			,	isSubcategory: this.isSubcategory
			
				// @property {Boolean} hasSubcategories
			,	hasSubcategories: hasSubcategories

				// @property {Boolean} showItems
			,	showItems: hasItems || (!hasItems && hasSelectedFacets) || !(!hasItems && !hasSelectedFacets && hasSubcategories)
			
				// @property {Boolean} isProductAlreadyAdded
			,	isProductAlreadyAdded: this.isProductAlreadyAdded

				//@property {Boolean} isLoggedIn
			,	isLoggedIn:	this.Profile.get('isLoggedIn') == "T" ? true : false
		};
			// @class Facets.Browse.View
		}
	});
});

